// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege, adEnabled } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { updateUsers } from '../../../stores/users/actionCreators';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];
    adEnabled?: boolean;

    updateUsers: (ids: string[]) => void;
}
interface State {
    showModal: boolean;
}

class UpdateUsersAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.adEnabled && this.props.hasPrivilege(['SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="no-icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.setState({ showModal: true });
                        }}
                    >
                        {t('users.button.migrate')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('users.modal.migrate.header') as string}
                        confirmText={t('users.modal.migrate.confirm') as string}
                        buttonColor="danger"
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.props.updateUsers(this.props.selected);
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('users.modal.migrate.text') as string}
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    adEnabled: adEnabled(state),
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'users'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    updateUsers: (ids: string[]) => dispatch(updateUsers(ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(UpdateUsersAction));